import LoadingSkeleton from "../components/LoadingSkeleton";
import type { View } from "./views";
import OverviewSkeleton, { type OverviewSkeletonProps } from "../features/overview/OverviewSkeleton";

export default function ScreenLoading({ view, older = false, overview }: { view: View; older?: boolean; overview: OverviewSkeletonProps }) {
  if (view === "overview") return <OverviewSkeleton {...overview} label={older ? "Loading older entries" : "Loading overview"} />;
  return <LoadingSkeleton layout={view === "insights" ? "insights" : view === "accounts" ? "accounts" : "list"}
    label={older ? "Loading older entries" : `Loading ${view.replaceAll("-", " ")}`} />;
}
